import type React from "react";
import { useQuery } from "@tanstack/react-query";
import { useCommonResourcesContextValue } from "../context";

export function AdminGuard({ children }: { children: React.ReactNode }) {
  const { createCurrentUserQueryOptions } = useCommonResourcesContextValue();

  const isAdminQuery = useQuery({
    ...createCurrentUserQueryOptions(),
    select(response) {
      // No current user indicates they're anonymous and so shouldn't have
      // access to admin resources
      return response.data !== null && response.data.admin;
    },
  });

  if (isAdminQuery.isSuccess && isAdminQuery.data) {
    return children;
  }

  return null;
}
